<!--
	PageBanner.svelte
-->

<script>
    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
	import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiArrowLeftCircle } from '@mdi/js';
    import { pop } from 'svelte-spa-router';

    export let title;
    export let isBold = false;

    onMount(() => {
    })

</script>

<style>
    .page-banner {
        width: 98%;
        padding: 10px 1% 10px 0%;
        margin: 20px 0px;
        color: var(--tcare-purple);
    }

    .back-icon {
        width: 36px;
        height: 36px;
        margin-right: 10px;
    }

    .back-icon:hover {
        transform: scale(1.2);
    }

    :global(.back-icon svg) {
        fill: var(--tcare-purple);
        transition: all .2s;
    }

    :global(.back-icon svg:hover) {
        fill: var(--tcare-secondary);
        transform: scale(1.1);
    }

    .banner-title {
        font-size: 32px;
        font-weight: 400;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="page-banner flex-row jc-start fs-2 fw-100">
    <div class="back-icon" on:click={() => pop()}>
        <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiArrowLeftCircle} /></Icon>	
    </div>

    <div class="flex-row jc-start">
        {#if isBold}
            <div class="banner-title"><b>{title}</b></div>
        {:else}
            <div class="banner-title">{title}</div>
        {/if}
    </div>

</div>
